import { useCurrentUser } from '~/hooks/useCurrentUser';
import { api } from '~/redux/api/createApi';
import { PilotId } from '~/types/PilotId';

export const DepartmentQuestionValue = ({
  departmentIds,
}: {
  departmentIds: PilotId[];
}) => {
  const currentUser = useCurrentUser();
  const { data: clientDepartmentsTree } =
    api.endpoints.getClientDepartmentsTree.useQuery(currentUser.client);

  const departmentMap =
    clientDepartmentsTree?.reduce(
      (acc: Record<number, string>, department: any) => {
        acc[department.department_id] = department.department_name;
        return acc;
      },
      {},
    ) ?? {};

  return (
    <>
      {departmentIds
        .map((departmentId) => departmentMap[departmentId] || departmentId)
        .join(' • ') ?? null}
    </>
  );
};
